"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const react_1 = __importStar(require("react"));
const Carousel_1 = __importDefault(require("./Carousel"));
function Slider({ category, height = 500 }) {
    const [data, setData] = (0, react_1.useState)([]);
    /** Generate Random String for use as id */
    const generateRandomString = (length = 6) => Math.random().toString(20).substring(2, length);
    const getImages = () => __awaiter(this, void 0, void 0, function* () {
        let imageList = (yield axios_1.default.get(`/api/get-images/${category}`)).data;
        let imageArray = [];
        imageList.forEach((image, index) => {
            imageArray.push({
                id: generateRandomString(19) + index,
                image: image.image,
                caption: "",
            });
        });
        setData(imageArray);
    });
    (0, react_1.useEffect)(() => {
        getImages();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, data.length > 0 ? (react_1.default.createElement(Carousel_1.default, { data: data, width: "100%", time: 5000, height: `${height}px`, captionPosition: "center", automatic: true, dots: true, pauseIconColor: "white", pauseIconSize: "40px", slideBackgroundColor: "darkgrey", slideImageFit: "cover", style: {
            textAlign: "center",
            maxWidth: "120rem",
            margin: "0 auto",
        } })) : (react_1.default.createElement("div", { style: {
            width: "100%",
            height: `${height}px`,
            backgroundColor: "darkgrey",
        } }))));
}
exports.default = Slider;
